import { Flex } from "@redotech/arbiter/flex";
import { Header, Text } from "@redotech/arbiter/text";

import * as styles from "./error-fallback.module.css";

export function ErrorFallback(): JSX.Element {
  return (
    <Flex
      align="center"
      as="main"
      className={styles.shell}
      justify="center"
      p="3xl"
      role="alert"
    >
      <Flex
        align="center"
        bgColor="primary"
        borderColor="secondary"
        borderRadius="2xl"
        borderStyle="solid"
        borderWidth="1px"
        className={styles.card}
        dir="column"
        gap="md"
        px="6xl"
        py="6xl"
      >
        <Header as="h1" fontSize="xxs" fontWeight="medium" m="none">
          Something went wrong
        </Header>
        <Text fontSize="sm" m="none" textAlign="center" textColor="disabled">
          Please reload the page or try again in a minute.
        </Text>
      </Flex>
    </Flex>
  );
}
